import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import {NgxPaginationModule} from 'ngx-pagination';
import {CommonModule, CurrencyPipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LoadingModule} from 'ngx-loading';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgxPermissionsModule} from 'ngx-permissions';
import {RouterModule} from '@angular/router';
import {routes} from './teamwork-reports.routing';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {PipesModule} from '../pipes/pipes.module';
import {TableModule} from 'primeng/table';
import {InputTextModule} from 'primeng/inputtext';
import {DropdownModule} from 'primeng/dropdown';
import {
  MatAutocompleteModule,
  MatDialogModule,
  MatRadioModule
} from '@angular/material';
import {OverlayPanelModule, TooltipModule} from 'primeng/primeng';
import {AppColoredLabelModule} from '../../components/app-colored-label/app-colored-label.module';
import {UnityChartModule} from '../../components/unity-chart/unity-chart.module';
import {AppSpinnerDivModule} from '../../components/app-spinner-div/app-spinner-div.module';
import {LocalDatePipe} from '../pipes/local-date.pipe';
import {DisplayFieldPipe} from '../pipes/displayField.pipe';
import {TableExtensionService} from '../../services/table-extension.service';
import {SortService} from '../../services/sort.service';
import {SharedModule} from '../../modules/shared.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TeamworkReportsComponent} from './teamwork-reports.component';
import {CompanyMappingComponent} from './company-mapping/company-mapping.component';
import {CompanyMappingService} from '../../services/company-mapping.service';
import {TicketsRepliesComponent} from './tickets-replies/tickets-replies.component';

@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    NgMultiSelectDropDownModule,
    NgxPaginationModule,
    NgxDatatableModule,
    LoadingModule,
    NgxPermissionsModule.forChild(),
    NgbModule,
    RouterModule.forChild(routes),
    PipesModule,
    TableModule,
    InputTextModule,
    DropdownModule,
    SharedModule,
    MatDialogModule,
    TooltipModule,
    MatAutocompleteModule,
    OverlayPanelModule,
    AppColoredLabelModule,
    MatRadioModule,
    UnityChartModule,
    AppSpinnerDivModule,
    MatSelectModule,
    BrowserAnimationsModule
  ],
  providers: [
    CompanyMappingService,
    LocalDatePipe,
    DisplayFieldPipe,
    CurrencyPipe,
    TableExtensionService,
    SortService
  ],
  declarations: [
      TeamworkReportsComponent,
      CompanyMappingComponent,
      TicketsRepliesComponent
  ],
  entryComponents: [
      TeamworkReportsComponent,
      CompanyMappingComponent,
      TicketsRepliesComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TeamworkReportsModule {
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/teamwork-reports/teamwork-reports.module.ts